import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
const navigate = useNavigate();

const actions = [
{
title: 'View Daily Digest',
description: 'Check today\'s top job matches',
icon: 'Mail',
variant: 'default',
onClick: () => navigate('/job-matching') 
},
{
title: 'Auto-Apply Settings',
description: 'Configure automatic applications',
icon: 'Settings',
variant: 'outline',
onClick: () => navigate('/settings') 
},
{
title: 'Mock interview',
description: 'Pass a simulated interview',
icon: 'Video',
variant: 'secondary',
onClick: () => navigate('/interviews')
}
];

return (
<div className="bg-card border border-border rounded-lg p-6">
<h3 className="text-base sm:text-lg font-semibold text-text-primary mb-6">Quick Actions</h3>
<div className="space-y-4">
{actions?.map((action, index) => (
<Button
key={index}
variant={action?.variant}
iconName={action?.icon}
iconPosition="left"
fullWidth
onClick={action?.onClick}
className="justify-start h-auto p-4"
>
<div className="text-left">
<div className="font-medium">{action?.title}</div>
<div className="text-sm opacity-70 mt-1">{action?.description}</div>
</div>
</Button>
))}
</div>
</div>
);
};

export default QuickActions;